import { render, staticRenderFns } from "./OpenOrder.vue?vue&type=template&id=2a04e370&scoped=true"
import script from "./OpenOrder.vue?vue&type=script&lang=js"
export * from "./OpenOrder.vue?vue&type=script&lang=js"
import style0 from "./OpenOrder.vue?vue&type=style&index=0&id=2a04e370&prod&lang=scss&scoped=true"
import style1 from "./OpenOrder.vue?vue&type=style&index=1&id=2a04e370&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a04e370",
  null
  
)

export default component.exports